var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _radialGradient, _linearGradient18, _radialGradient2, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -8 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 0 3012.411232)",
    gradientUnits: "userSpaceOnUse",
    x1: 216.75,
    x2: 216.75,
    xlinkHref: "#lg1",
    y1: 2638.8948,
    y2: 2520.3899
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 1756.862745 2851.783781)",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.75,
    x2: 1376.75,
    xlinkHref: "#lg1",
    y1: 2478.8948,
    y2: 2360.3899
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1756.862745 -8.388768)",
    gradientUnits: "userSpaceOnUse",
    x1: 1655,
    x2: 1655,
    xlinkHref: "#lg1",
    y1: 473.1051,
    y2: 370.1051
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 139.2941775,
    x2: 139.2941775,
    xlinkHref: "#lg1",
    y1: 125.2383702022,
    y2: 48.4383372022
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1756.862745 -8.388768)",
    gradientUnits: "userSpaceOnUse",
    x1: 1378.75,
    x2: 1378.75,
    xlinkHref: "#lg1",
    y1: 133.1051,
    y2: 22.6051
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 1756.862745 -8.388768)",
    gradientUnits: "userSpaceOnUse",
    x1: 1495,
    x2: 1495,
    xlinkHref: "#lg1",
    y1: 133.1051,
    y2: 30.1051
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 185.0260413824,
    y2: 425.1681994704
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 224.1770919306,
    y2: 384.1403167432
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 236.7762084064,
    x2: 260.510731546,
    xlinkHref: "#lg2",
    y1: 288.3258002788,
    y2: 436.6661181364
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 313.5547574756,
    x2: 184.0552445764,
    xlinkHref: "#lg3",
    y1: 388.2123247674,
    y2: -281.8720792378
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 241.2802040672,
    x2: 339.1577802416,
    xlinkHref: "#lg2",
    y1: 75.8465121164,
    y2: 256.5434368184
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 0 2883.060456)",
    gradientUnits: "userSpaceOnUse",
    x1: 223.2524,
    x2: 223.2524,
    xlinkHref: "#lg1",
    y1: 2453.0303,
    y2: 2656.7649
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 0 2883.060456)",
    gradientUnits: "userSpaceOnUse",
    x1: 325.1809,
    x2: 325.1809,
    xlinkHref: "#lg1",
    y1: 2453.0303,
    y2: 2656.7649
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#fec33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#fbb840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#f6a649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#f08d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 84.9836035752,
    cy: 442.4777222022,
    gradientUnits: "userSpaceOnUse",
    r: 46.725541646,
    xlinkHref: "#lg4"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 89.349058,
    x2: 107.9825530654,
    y1: 53.9599082022,
    y2: 72.5935036598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    cx: 245.6111235752,
    cy: -9.0760530012,
    gradientUnits: "userSpaceOnUse",
    r: 46.725541646,
    xlinkHref: "#lg4"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4139,
    stopColor: "#1fa999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 400.062917,
    x2: 432.1649292252,
    xlinkHref: "#lg5",
    y1: 7.2775352022,
    y2: 39.3795474274
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 158.055973797,
    x2: 193.8890621352,
    xlinkHref: "#lg5",
    y1: 456.7617252026,
    y2: 492.594913933
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: 404.3514709996,
    x2: 436.3442565112,
    y1: 458.1003547974,
    y2: 490.093140309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear17",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9564526306,
    x2: 271.0662686306,
    xlinkHref: "#lg3",
    y1: 377.8193226546,
    y2: 412.9565926546
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear18",
    gradientUnits: "userSpaceOnUse",
    x1: 332.3776926224,
    x2: 365.1724110276,
    xlinkHref: "#lg3",
    y1: 380.584324627,
    y2: 415.721594627
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear19",
    gradientUnits: "userSpaceOnUse",
    x1: 84.7218811098,
    x2: 132.9101371098,
    xlinkHref: "#lg3",
    y1: 378.23163342,
    y2: 427.42381142
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear20",
    gradientUnits: "userSpaceOnUse",
    x1: 178.3583887952,
    x2: 142.2171967952,
    xlinkHref: "#lg3",
    y1: 134.6699162156,
    y2: 55.3600782156
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear21",
    gradientUnits: "userSpaceOnUse",
    x1: 336.9637087106,
    x2: 314.3754637106,
    xlinkHref: "#lg3",
    y1: 121.80485657,
    y2: 78.63621057
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear22",
    gradientUnits: "userSpaceOnUse",
    x1: 269.3123165044,
    x2: 228.6534755044,
    xlinkHref: "#lg3",
    y1: 137.5480601974,
    y2: 97.3911801974
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m227.308594 482.136719h-51.621094v-15.058594h51.621094c9.453125 0 17.144531-7.691406 17.144531-17.144531v-86.765625h15.0625v86.765625c0 17.757812-14.449219 32.203125-32.207031 32.203125zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m416.628906 482.136719h-51.625c-17.757812 0-32.203125-14.445313-32.203125-32.203125v-86.765625h15.058594v86.765625c0 9.453125 7.691406 17.144531 17.144531 17.144531h51.625zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m87.84375 363.167969h15.058594v103.402343h-15.058594zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m181.207031 125.238281h-15.058593v-44.59375c0-9.457031-7.691407-17.148437-17.144532-17.148437h-51.625v-15.058594h51.625c17.757813 0 32.203125 14.449219 32.203125 32.207031zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m345.851562 125.238281h-15.058593v-78.730469c0-17.753906 14.445312-32.203124 32.203125-32.203124h51.625v15.058593h-51.625c-9.453125 0-17.144532 7.691407-17.144532 17.144531zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m248.46875 21.835938h15.0625v103.402343h-15.0625zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m487.332031 415.039062h-462.664062c-13.625 0-24.667969-11.046874-24.667969-24.671874v-269.238282c0-13.625 11.042969-24.667968 24.667969-24.667968h462.664062c13.625 0 24.667969 11.042968 24.667969 24.667968v269.238282c0 13.625-11.042969 24.671874-24.667969 24.671874zm0 0",
    fill: "url(#linear6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m512 121.132812v269.230469c0 7.160157-3.050781 13.613281-7.921875 18.109375-4.386719 4.078125-10.269531 6.566406-16.746094 6.566406h-462.664062c-6.476563 0-12.359375-2.488281-16.746094-6.566406-4.871094-4.496094-7.921875-10.949218-7.921875-18.109375v-269.230469c0-7.160156 3.050781-13.613281 7.921875-18.113281 4.386719-4.074219 10.269531-6.5625 16.746094-6.5625h462.664062c6.476563 0 12.359375 2.488281 16.746094 6.5625 4.871094 4.5 7.921875 10.953125 7.921875 18.113281zm0 0",
    fill: "url(#linear7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m504.078125 408.472656c-4.386719 4.078125-10.269531 6.566406-16.746094 6.566406h-462.664062c-6.476563 0-12.359375-2.488281-16.746094-6.566406l227.15625-188.144531c12.136719-10.058594 29.707031-10.058594 41.84375 0zm0 0",
    fill: "url(#linear8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m487.332031 415.039062c6.476563 0 12.359375-2.488281 16.746094-6.566406 4.871094-4.496094 7.921875-10.949218 7.921875-18.109375v-269.230469c0-3.375-.6875-6.589843-1.914062-9.519531-.390626-.164062-.789063-.320312-1.191407-.464843l.71875-.59375c-.539062-1.132813-1.160156-2.21875-1.859375-3.25-1.691406-1.144532-3.53125-2.085938-5.484375-2.785157l1.808594-1.5c-4.386719-4.074219-10.269531-6.5625-16.746094-6.5625h-462.664062c-6.476563 0-12.359375 2.488281-16.746094 6.5625l313.199219 312.019531zm0 0",
    fill: "url(#linear9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m504.078125 103.019531-227.15625 188.148438c-12.136719 10.058593-29.707031 10.058593-41.84375 0l-227.15625-188.148438c4.386719-4.074219 10.269531-6.5625 16.746094-6.5625h462.664062c6.476563 0 12.359375 2.488281 16.746094 6.5625zm0 0",
    fill: "url(#linear10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m285.832031 363.816406h-123.410156c-1.894531 0-3.429687 1.539063-3.429687 3.429688v6.214844c0 1.894531 1.539062 3.429687 3.429687 3.429687h123.410156c1.894531 0 3.429688-1.535156 3.429688-3.429687v-6.214844c0-1.894532-1.535157-3.429688-3.429688-3.429688zm0 0",
    fill: "url(#linear11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m349.578125 363.816406h-46.242187c-1.894532 0-3.429688 1.539063-3.429688 3.429688v6.214844c0 1.894531 1.539062 3.429687 3.429688 3.429687h46.242187c1.894531 0 3.429687-1.535156 3.429687-3.429687v-6.214844c0-1.894532-1.539062-3.429688-3.429687-3.429688zm0 0",
    fill: "url(#linear12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m117.207031 473.386719c0 12.058593-9.777343 21.835937-21.835937 21.835937s-21.832032-9.777344-21.832032-21.835937c0-12.058594 9.773438-21.832031 21.832032-21.832031s21.835937 9.773437 21.835937 21.832031zm0 0",
    fill: "url(#radial0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m117.207031 59.984375c0 12.058594-9.777343 21.832031-21.835937 21.832031s-21.832032-9.773437-21.832032-21.832031 9.773438-21.835937 21.832032-21.835937 21.835937 9.777343 21.835937 21.835937zm0 0",
    fill: "url(#linear13)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m277.835938 21.835938c0 12.058593-9.777344 21.832031-21.835938 21.832031s-21.835938-9.773438-21.835938-21.832031c0-12.058594 9.777344-21.835938 21.835938-21.835938s21.835938 9.777344 21.835938 21.835938zm0 0",
    fill: "url(#radial1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m436.453125 21.835938c0 12.058593-9.773437 21.832031-21.832031 21.832031s-21.835938-9.773438-21.835938-21.832031c0-12.058594 9.777344-21.835938 21.835938-21.835938s21.832031 9.777344 21.832031 21.835938zm0 0",
    fill: "url(#linear14)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m196.515625 473.386719c0 12.058593-9.773437 21.835937-21.832031 21.835937s-21.835938-9.777344-21.835938-21.835937c0-12.058594 9.777344-21.832031 21.835938-21.832031s21.832031 9.773437 21.832031 21.832031zm0 0",
    fill: "url(#linear15)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m441.472656 473.386719c0 12.058593-9.773437 21.835937-21.832031 21.835937s-21.835937-9.777344-21.835937-21.835937c0-12.058594 9.777343-21.832031 21.835937-21.832031s21.832031 9.773437 21.832031 21.832031zm0 0",
    fill: "url(#linear16)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m244.453125 363.167969h15.0625v51.871093h-15.0625zm0 0",
    fill: "url(#linear17)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m332.800781 363.167969h15.058594v51.871093h-15.058594zm0 0",
    fill: "url(#linear18)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m87.84375 363.167969h15.058594v51.871093h-15.058594zm0 0",
    fill: "url(#linear19)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m166.148438 96.457031h15.058593v55.886719h-15.058593zm0 0",
    fill: "url(#linear20)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m330.792969 96.457031h15.058593v55.886719h-15.058593zm0 0",
    fill: "url(#linear21)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m248.46875 96.457031h15.0625v55.886719h-15.0625zm0 0",
    fill: "url(#linear22)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.b4d7d8520f9de379ab7c18dce8391f82.svg";
export { ForwardRef as ReactComponent };